import useAxios from '../../../../hooks/useAxios'
import { IStockReport, IStockReportDetail } from './types'

interface Params {
  platform: string
  startDate?: string
  endDate?: string
  shopId?: string
  // ปิดการยิงเมื่อยังไม่พร้อม (เช่นรอผู้ใช้เลือกช่วงวัน)
  enabled?: boolean
}

const buildParams = (params: Params) => ({
  platform: params.platform,
  startDate: params.startDate,
  endDate: params.endDate,
  ...(params.shopId ? { shopId: params.shopId } : {}),
})

// การ์ดภาพรวม + ตารางรายวัน — BE คืนมาใน request เดียว
export const useStockReport = (params: Params) => {
  const { startDate, endDate, enabled = true } = params
  return useAxios<IStockReport>(
    enabled && startDate && endDate
      ? {
          method: 'GET',
          url: '/product/stock-report',
          params: buildParams(params),
        }
      : null,
  )
}

// รายละเอียดของช่วงที่เลือก แยกรายสินค้า + รายการที่ตัดไม่ได้
export const useStockReportDetail = (params: Params) => {
  const { startDate, endDate, enabled = true } = params
  return useAxios<IStockReportDetail>(
    enabled && startDate && endDate
      ? {
          method: 'GET',
          url: '/product/stock-report/products',
          params: buildParams(params),
        }
      : null,
  )
}
